import { consumer, core } from '@tock/coretypes';

import { DiscountCodeForm } from 'forms/DiscountCodeForm';
import BaseComponent from '@tock/shared/components/BaseComponent';
import LoyaltyProgram from 'components/loyalty-program/LoyaltyProgram';

import { StoreType } from '@tock/shared/utils/connect';
import { Typography } from 'omakase';

interface Props {
  business: consumer.IBusinessConfig;
  loyaltyProgram: StoreType['loyaltyProgram'];
  onApplyDiscountCode(discountCode: string): void;
  onEditLoyaltyProgramLogin(): void;
  onEditLoyaltyProgramRedemption(): void;
  onRemoveDiscountCode(): void;
  onShowLoyaltyProgramLogin(): void;
  purchaseOrder?: core.PurchaseOrder;
  showLoyaltyProgram: boolean;
  showDiscountCodeForm: boolean;
  ticketType?: core.ITicketType;
  ticketTypeDiscountCode?: core.TicketTypePromoCode;
}

export default class RewardsAndDiscountsForm extends BaseComponent<Props> {
  render() {
    const {
      onApplyDiscountCode,
      onEditLoyaltyProgramLogin,
      onEditLoyaltyProgramRedemption,
      onShowLoyaltyProgramLogin,
      onRemoveDiscountCode,
      purchaseOrder,
      loyaltyProgram,
      showLoyaltyProgram,
      showDiscountCodeForm,
      ticketType,
      ticketTypeDiscountCode,
      business,
    } = this.props;

    return (
      <div className="ConsumerCheckout-section">
        {showLoyaltyProgram && showDiscountCodeForm && (
          <div className="ConsumerCheckout-paymentHeader">
            <h2>
              <Typography color="inherit" component="span" variant="body02Strong">
                Rewards and discounts
              </Typography>
            </h2>
          </div>
        )}
        <div className="Receipt-container--body ConsumerCheckout-rewardsAndDiscounts">
          {showDiscountCodeForm && (
            <DiscountCodeForm
              onApplyDiscountCode={onApplyDiscountCode}
              onRemoveDiscountCode={onRemoveDiscountCode}
              purchaseOrder={purchaseOrder}
              ticketTypeDiscountCode={ticketTypeDiscountCode}
            />
          )}
          {showLoyaltyProgram && (
            <LoyaltyProgram
              onEditLogin={onEditLoyaltyProgramLogin}
              onEditRedemption={onEditLoyaltyProgramRedemption}
              onShowLogin={onShowLoyaltyProgramLogin}
              loyaltyProgram={loyaltyProgram}
              ticketType={ticketType}
              business={business}
              purchaseOrder={purchaseOrder}
            />
          )}
        </div>
      </div>
    );
  }
}
